import { MenuItem } from 'common/styles';
import React, { useState } from 'react';
import SelectInput, { SelectInputProps, SelectValue } from './SelectInput';
import { InputSize } from './theme';

export type SelectOption<T = SelectValue> = {
  value: T,
  label: string,
  isActive?: boolean,
};

export type SelectProps<T = SelectValue> = SelectInputProps<T> & {
  options?: SelectOption<T>[];
  inputSize?: InputSize;
};

export default function Select<T extends SelectValue = SelectValue>({
  options, children, ...rest
}: SelectProps<T>) {
  if (!options) return <SelectInput {...rest}>{children}</SelectInput>;

  return (
    <SelectInput {...rest}>
      {options.map(({ value, label }) => (
        <MenuItem key={value} value={value} isActive={value === rest.value}>
          {/* to fix height issue if label is empty */}
          {label || <span dangerouslySetInnerHTML={{ __html: '&#8203;' }} />}
        </MenuItem>
      ))}
    </SelectInput>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Example1 = () => {
  const [val, setVal] = useState('');
  return (
    <Select value={val} placeholder="choose gender" onChange={(x) => setVal(x.target.value)}>
      <MenuItem value="m">male</MenuItem>
      <MenuItem value="f">female</MenuItem>
      <MenuItem value="n">prefer no to say</MenuItem>
    </Select>
  );
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Example2 = () => {
  const [val, setVal] = useState('');
  const options: SelectOption<string>[] = [
    { label: 'male', value: 'm' },
    { label: 'female', value: 'f' },
    { label: 'prefer no to say', value: 'n' },
  ];
  return (
    <Select value={val} placeholder="choose gender" onChange={(x) => setVal(x.target.value)} options={options} />
  );
};
